import { z } from 'zod';
import { idValidator } from '@/schemas/common/validators';

// Request schema for bulk feature
export const BulkFeatureRequestSchema = z.object({
  listingIds: z.array(idValidator).min(1, 'At least one listing ID is required'),
  featured: z.boolean(),
});

export type BulkFeatureRequest = z.infer<typeof BulkFeatureRequestSchema>;

// Response schema for bulk feature
export const BulkFeatureResponseSchema = z.discriminatedUnion('success', [
  z.object({
    success: z.literal(true),
    featured: z.boolean(),
    updatedCount: z.number(),
    totalRequested: z.number(),
  }),
  z.object({
    success: z.literal(false),
    error: z.string(),
    found: z.number().optional(),
    requested: z.number().optional(),
    details: z.string().optional(),
  }),
]);

export type BulkFeatureResponse = z.infer<typeof BulkFeatureResponseSchema>;
